<div class="photo-manager">
  <mat-spinner 
    *ngIf="!ready" 
    diameter="40"
  />

  <!-- Tabella -->
  <div *ngIf="photos.length > 0; else addFirstPhoto">
    <h2 >PHOTOS</h2>
    <table class="photo-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Photo</th>
          <th>Title</th>
          <th>Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let photo of photos; let i = index">
          <td class="order">
            <span class="num">
              {{ i + 1 }}
            </span>
            <input type="checkbox" name="on" [checked]="photo.on" >
          </td>
          <td class="url-cell" title="{{ photo.url }}">{{ photo.url }}</td>
          <td>{{ photo.title }}</td>
          <td>{{ photo.description }}</td>
          <td class="action-buttons">
            <button (click)="editRecord(i)">
              <mat-icon>edit</mat-icon>
            </button>
            <button (click)="removeRecord(i)">
              <mat-icon>delete</mat-icon>
            </button>
            <button (click)="reorderRecord(i, 'up')" [disabled]="i === 0">
              <mat-icon>arrow_upward_alt</mat-icon>
            </button>
            <button (click)="reorderRecord(i, 'down')" [disabled]="i === photos.length - 1">
              <mat-icon>arrow_downward_alt</mat-icon>
            </button>
            <button (click)="addRecord(i)">
              <mat-icon>add</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ng-template #addFirstPhoto>
    <div
      class="add-first-photo"
      (click)="addRecord(-1)"
    >
      ADD A PHOTO
    </div>
  </ng-template>
  
</div>